import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Link } from 'react-router'

import Footer from './footer.jsx'
import { initSession, resetUserSession, updateAPILanguage } from '../actions/user';
import { DEBUG, GET_TOKEN_URL} from '../config';
import { logError } from '../utils';
import { connect } from 'react-redux';
import jQuery from 'jquery';
import $ from 'jquery';
import { LinkContainer } from 'react-router-bootstrap';







class Megamenu extends Component {




  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent)
  }


 componentWillMount(){
    this.startErrorLog();
    this.props.initSession(this.props.location);
  }

    startErrorLog() {

      $('body').on('mouseenter mouseleave','.dropdown',function(e){
  var _d=$(e.target).closest('.dropdown');_d.addClass('show');
  setTimeout(function(){
    _d[_d.is(':hover')?'addClass':'removeClass']('show');
    $('[data-toggle="dropdown"]', _d).attr('aria-expanded',_d.is(':hover'));
      },0);
    });

    if(!DEBUG) { // in prodution, we log all errors and hide console logs
      console.log = function() {}
      console.log("window.onerror started")
      window.onerror = (message, file, line, column, errorObject) => {
        console.log("window.onerror caught")
        column = column || (window.event && window.event.errorCharacter);
        let stack = errorObject ? errorObject.stack : null;

        // trying to get stack from IE
        if(!stack) {
          stack = [];
          let f = arguments.callee.caller;
          while (f) {
            stack.push(f.name);
            f = f.caller;
          }
          errorObject['stack'] = stack;
        }

        const store = window.store.getState()

        const body = {
          message:message,
          file:file,
          line:line,
          column:column,
          errorStack:stack,
          form: store.form,
          userId: "userId : " + store.user.userId + "userStatus : " + store.user.status + "userError : " + store.user.error + "userAccount : " + store.user.accountType,
        };

        logError(window.location.href, JSON.stringify(body, null, 2))

        // the error can still be triggered as usual, we just want to know what's happening on the client side
        return false;
      }
    }
  }



  renderBody() {




       const isLoggedIn = this.props.user.status === 'authenticated';

    let loginUrl;
    if(this.props.nextPage) {
      loginUrl = GET_TOKEN_URL + '&state=' + this.props.nextPage;
    } else {
      loginUrl = GET_TOKEN_URL + '&state=' + this.props.currentUrl;
    }
    // if we let a slash at the end of a parameter, the account server will fail to redirect us
    loginUrl = loginUrl.replace(/\/$/, "");






    if (this.props.user.initEnded) {


    return (

           <div className="wrapper">
            <header id="header " className="header page-interne ">
            <div className="container header-inner ">

                    <a href="/" className="logotype_one">
                        <img className="logo-light" src="/assets/img/white_logo.png" alt="greenAgro" />

                    </a>
                    <a href="/" className="logotype_one fixed">
                        <img className="logo-light" src="/assets/img/greenagro.png" alt="greenAgro" />

                    </a>




                <button className="navbar-toggler nav-mobile nav-bar-icon d-xl-none d-md-none"
                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                aria-label="Toggle navigation">
                 <i className="fa fa-bars"></i>
                </button>


          <div className="nav-menu collapse navbar-collapse  d-md-block d-lg-block" id="navbarNavAltMarkup">
            <ul className="nav-menu-inner">

            <NavDropdown to='/communaute/presentation' eventKey={4} title={"Green Agro Business"} className="edition2016" id="basic-nav-dropdown">

              <LinkContainer to='/qui-sommes-nous'>
                <MenuItem eventKey={4.2} xs={12} sm={12} className="dropdown-item" id="sous_item">Qui sommes-nous?</MenuItem>
              </LinkContainer>

              <LinkContainer to='/notre-usine'>
                <MenuItem eventKey={4.2} xs={12} sm={12} className="dropdown-item" id="sous_item">Notre usine</MenuItem>
              </LinkContainer>



              <li className="dropdown-item tech_link"><a href='/nos-engagements'>Nos engagements</a></li>
              <LinkContainer to='/rse'>
                <MenuItem eventKey={4.2} xs={12} sm={12} className="dropdown-item" id="sous_item">Nos réalisations RSE</MenuItem>
              </LinkContainer>


            </NavDropdown>
            <NavDropdown eventKey={4} title={"Produits"} className="edition2016" id="basic-nav-dropdown">
              <li className="dropdown-item"><a href='/produits/teranga' id="sous_item"><img src="/assets/img/logos/teranga.png" className="teranga_img teranga_img_menu"/></a></li>
              <li className="dropdown-item teranga"><a href='/produits/teranga-plus' id="sous_item"> <img src="/assets/img/logos/terangaplus.png" className="terangaplus_img terangaplus_img_menu"/></a></li>
              {/*<li className="dropdown-item"><a href='/certification-bio' id="sous_item">Certification Bio</a></li>*/}
            </NavDropdown>
            <NavDropdown to='/communaute/presentation' eventKey={4} title={"Services"} className="edition2016" id="basic-nav-dropdown">
              {/*<LinkContainer to='/technicien-conseil'>
                              <MenuItem eventKey={4.2} xs={12} sm={12} className="dropdown-item" id="sous_item">Techniciens conseils </MenuItem>
                            </LinkContainer>*/}
              <li className="dropdown-item tech_link"><a href='/technicien-conseil'>Techniciens conseils</a></li>

                <li className="dropdown-item tech_link"><a href='/recherche-et-innovation'>Recherche & innovation</a></li>


              {/*<LinkContainer to='/notre-equipe'>
                              <MenuItem eventKey={4.2} xs={12} sm={12} className="dropdown-item" id="sous_item">Notre équipe</MenuItem>
                            </LinkContainer>*/}
            </NavDropdown>


              <li>
            <a href='/nos-partenaires'>
             Partenaires
            </a></li>
            <li><a href='/recrutement'>Recrutement</a></li>




              <li>
            <a href='/contact'>
             Contact
            </a></li>

            </ul>

          </div>



            </div>
        </header>





               { this.props.children}

                <Footer/>


</div>
            );
            } else {
      return(
       <div className="container">
          <div className="row" >
            <nav role="navigation" className="navbar navbar-default navbar-fixed-top">
              <div className="container">
                <div className="navbar-header col-md-9 col-lg-9 col-sm-8">
                  <a className="navbar-brand" href="/">

                    </a>
                </div>
              </div>
            </nav>
          </div>

        </div>
      );
    }
    }

  render() {

    return(
      <div>
        {this.renderBody()}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
    accountType: state.user.accountType,
    profilePicture: state.user.profilePictureUrl,
    currentUrl: ownProps.location.pathname,
    nextPage: ownProps.location.query.next,
    notificationMessages: state.notificationMessages,
  };
}



export default (connect(mapStateToProps, { initSession, resetUserSession, updateAPILanguage })(Megamenu));



// WEBPACK FOOTER //
// ./src/components/header.jsx